/* Schede da fuori di testa, fase 3 (C, 14/10/2026). Il video parte solo quando entra nello schermo, mai con prefers-reduced-motion e mai
   dopo «Ferma il movimento»; il tasto pausa ferma il video; «Manda questa pagina» usa la condivisione del telefono o copia il link;
   «Scegli la taglia» riporta alle taglie della cassa del tema. Niente librerie.
   Fase 3b (C2, 14/10/2026), decisione 8: sotto i 750 px di larghezza si prende il 480p (data-src-piccolo) e il poster piccolo,
   da 750 in su il 720p. La scelta si fa una volta, quando il video sta per entrare nello schermo.
   Fase 3d (C4, 15/10/2026). Decisione 26: «Ferma il movimento» ferma anche la scritta scorrevole del tema (ticker), con la stessa classe
   e lo stesso testo del suo tasto «Ferma la scritta», così i due tasti dicono la stessa cosa; «Riprendi il movimento» la fa ripartire, ma
   solo se l'aveva fermata questo tasto. Decisione 22: le immagini del capitolo possono stare in un <picture> con una <source> per il
   telefono, che si accende insieme all'immagine. */
(function () {
  var d = document, html = d.documentElement;
  var sez = d.querySelector('[data-bh-u]');
  if (!sez) return;
  var ridotto = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var CHIAVE = 'bh-u-fermo';
  var fermo = false;
  try { fermo = localStorage.getItem(CHIAVE) === '1'; } catch (e) {}
  var avviso = sez.querySelector('[data-bh-u-avviso]');
  var btnFerma = sez.querySelector('[data-bh-u-ferma]');
  var v = sez.querySelector('.bh-u__v');
  var btnPausa = sez.querySelector('[data-bh-u-pausa]');
  var inVista = false, pausaUtente = false;
  var largo = function () { return window.matchMedia ? window.matchMedia('(min-width: 750px)').matches : true; };
  var scegli = function (el, grande, piccolo) {
    var g = el.getAttribute(grande), p = el.getAttribute(piccolo);
    el.removeAttribute(grande); el.removeAttribute(piccolo);
    return (p && !largo()) ? p : (g || p);
  };

  function di(msg) { if (avviso) { avviso.textContent = msg; setTimeout(function () { avviso.textContent = ''; }, 2600); } }

  function carica() {
    if (!v || v.getAttribute('data-caricato')) return;
    var pp = scegli(v, 'data-poster', 'data-poster-piccolo'); if (pp) v.poster = pp;
    var s = v.querySelector('source[data-src]');
    if (s) {
      var grande = s.getAttribute('data-src');
      var u = scegli(s, 'data-src', 'data-src-piccolo');
      if (grande && u !== grande) {
        // il 480p non c'è (o il nome è cambiato): si torna al 720p
        s.addEventListener('error', function () { s.src = grande; v.load(); suona(); }, { once: true });
      }
      s.src = u; v.load();
    }
    v.setAttribute('data-caricato', '1');
  }
  function puoMuovere() { return !fermo && !ridotto.matches && !pausaUtente; }
  function aggiornaPausa() {
    if (!btnPausa) return;
    var inPausa = !v || v.paused;
    btnPausa.setAttribute('aria-pressed', inPausa ? 'true' : 'false');
    var t = inPausa ? btnPausa.getAttribute('data-play') : btnPausa.getAttribute('data-pausa');
    var n = btnPausa.querySelector('.bh-u__nascosto');
    if (n && t) n.textContent = t;
  }
  function suona() {
    if (!v) return;
    if (inVista && puoMuovere()) {
      carica();
      var p = v.play();
      if (p && p.catch) p.catch(function () { aggiornaPausa(); });
    } else if (!v.paused) v.pause();
    aggiornaPausa();
  }
  if (v) {
    v.addEventListener('play', aggiornaPausa);
    v.addEventListener('pause', aggiornaPausa);
    // Si osserva solo dopo «load»: prima i fogli di stile del tema arrivano in ritardo (media=print) e la pagina corta
    // farebbe credere il video vicino allo schermo, scaricandolo con la prima schermata.
    // Il poster arriva quando il video e' a 800 px dallo schermo, il video quando e' a 200 px.
    var poster = function () { var p = scegli(v, 'data-poster', 'data-poster-piccolo'); if (p) v.poster = p; };
    var osserva = function () {
      if (!('IntersectionObserver' in window)) { poster(); return; }
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) poster(); }, { rootMargin: '800px 0px' }).observe(v);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inVista = e.isIntersecting; suona(); });
      }, { rootMargin: '200px 0px' }).observe(v);
    };
    if (d.readyState === 'complete') osserva(); else window.addEventListener('load', osserva);
  }
  if (btnPausa) btnPausa.addEventListener('click', function () {
    if (!v) return;
    if (v.paused) { pausaUtente = false; if (fermo) imposta(false); carica(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    else { pausaUtente = true; v.pause(); }
  });
  // Decisione 26. Le scritte scorrevoli del tema: quelle col loro tasto (data-bh-ticker, sezione ticker del tema) si fermano con la classe
  // bh-ticker--ferma del tema e il tasto passa al suo testo «Fai scorrere la scritta»; le altre con lo stile in linea. Si segna quali ha
  // fermato questo tasto (data-bh-u-fermata), e «Riprendi il movimento» fa ripartire solo quelle. Se chi visita usa il tasto del tema,
  // il segno si toglie e la scelta resta sua.
  function scritte(f) {
    var bersagli = [];
    d.querySelectorAll('[data-bh-ticker]').forEach(function (b) {
      var t = d.getElementById(b.getAttribute('data-bh-ticker'));
      if (!t) return;
      bersagli.push(t);
      if (f && !t.classList.contains('bh-ticker--ferma')) {
        t.classList.add('bh-ticker--ferma'); t.setAttribute('data-bh-u-fermata', '1');
        if (b.getAttribute('data-testo-riparti')) b.textContent = b.getAttribute('data-testo-riparti');
      } else if (!f && t.getAttribute('data-bh-u-fermata')) {
        t.classList.remove('bh-ticker--ferma'); t.removeAttribute('data-bh-u-fermata');
        if (b.getAttribute('data-testo-ferma')) b.textContent = b.getAttribute('data-testo-ferma');
      }
    });
    d.querySelectorAll('.ticker__container').forEach(function (c) {
      for (var i = 0; i < bersagli.length; i++) if (bersagli[i].contains(c)) return;
      if (f && !c.style.animationPlayState) { c.style.animationPlayState = 'paused'; c.setAttribute('data-bh-u-fermata', '1'); }
      else if (!f && c.getAttribute('data-bh-u-fermata')) { c.style.animationPlayState = ''; c.removeAttribute('data-bh-u-fermata'); }
    });
  }
  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bh-ticker]') : null;
    if (!b) return;
    var t = d.getElementById(b.getAttribute('data-bh-ticker'));
    if (t) t.removeAttribute('data-bh-u-fermata');
  }, true);
  function imposta(f) {
    fermo = f;
    try { localStorage.setItem(CHIAVE, f ? '1' : '0'); } catch (e) {}
    html.classList.toggle('bh-u-fermo', f);
    if (btnFerma) {
      btnFerma.setAttribute('aria-pressed', f ? 'true' : 'false');
      btnFerma.textContent = f ? (sez.getAttribute('data-riprendi') || btnFerma.textContent) : (sez.getAttribute('data-ferma') || btnFerma.textContent);
    }
    d.querySelectorAll('video').forEach(function (x) { if (f && !x.paused && x.closest('.bh-u')) x.pause(); });
    scritte(f);
    suona();
  }
  if (btnFerma) btnFerma.addEventListener('click', function () { imposta(!fermo); });
  if (ridotto.addEventListener) ridotto.addEventListener('change', suona);
  imposta(fermo);

  // Le immagini del capitolo si accendono a 600 px dallo schermo, dopo «load» (col solo loading=lazy Chromium le prende subito)
  var imm = sez.querySelectorAll('img[data-bh-u-srcset]');
  var accendi = function (i) {
    var pic = i.parentNode && i.parentNode.nodeName === 'PICTURE' ? i.parentNode : null;
    if (pic) pic.querySelectorAll('source[data-bh-u-srcset]').forEach(function (so) {
      so.srcset = so.getAttribute('data-bh-u-srcset'); so.removeAttribute('data-bh-u-srcset');
    });
    var s = i.getAttribute('data-bh-u-srcset'), u = i.getAttribute('data-bh-u-src');
    if (s) i.srcset = s;
    if (u) i.src = u;
    i.removeAttribute('data-bh-u-srcset'); i.removeAttribute('data-bh-u-src');
  };
  var guardaImm = function () {
    if (!('IntersectionObserver' in window)) { imm.forEach(accendi); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { accendi(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    imm.forEach(function (i) { io.observe(i); });
  };
  if (d.readyState === 'complete') guardaImm(); else window.addEventListener('load', guardaImm);

  // Decisione 10 anche per il titolo del capitolo: parole che non si spezzano, misura ridotta solo se una parola non entra
  var tit = sez.querySelector('.bh-u__titolo');
  if (tit && !tit.getAttribute('data-bh-u-parole')) {
    var tt = (tit.textContent || '').replace(/\s+/g, ' ').trim();
    if (tt) {
      tit.textContent = '';
      tt.split(' ').forEach(function (p, i) {
        if (i) tit.appendChild(d.createTextNode(' '));
        var sp = d.createElement('span'); sp.className = 'bh-u-parola'; sp.textContent = p; tit.appendChild(sp);
      });
      tit.setAttribute('data-bh-u-parole', '1');
    }
  }
  var adattaTit = function () {
    if (!tit) return;
    tit.style.fontSize = '';
    var w = tit.clientWidth, m = 0, ps = tit.querySelectorAll('.bh-u-parola');
    for (var i = 0; i < ps.length; i++) m = Math.max(m, ps[i].getBoundingClientRect().width);
    if (w && m > w + 0.5) tit.style.fontSize = (Math.floor(parseFloat(getComputedStyle(tit).fontSize) * w / m * 0.98 * 10) / 10) + 'px';
  };
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(adattaTit); else adattaTit();
  window.addEventListener('load', adattaTit);
  var tTit = 0;
  window.addEventListener('resize', function () { clearTimeout(tTit); tTit = setTimeout(adattaTit, 150); });

  var manda = sez.querySelector('[data-bh-u-manda]');
  if (manda) manda.addEventListener('click', function () {
    var url = location.href.split('#')[0];
    var dati = { title: manda.getAttribute('data-titolo') || d.title, text: manda.getAttribute('data-testo') || '', url: url };
    if (navigator.share) { navigator.share(dati).catch(function () {}); return; }
    var copiato = function () { di(sez.getAttribute('data-copiato') || ''); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(copiato, function () {});
    else {
      var t = d.createElement('textarea'); t.value = url; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      d.body.appendChild(t); t.select(); try { d.execCommand('copy'); copiato(); } catch (e) {} d.body.removeChild(t);
    }
  });

  var taglia = sez.querySelector('[data-bh-u-taglia]');
  if (taglia) taglia.addEventListener('click', function (e) {
    var dest = d.getElementById('bh-taglie');
    if (!dest) return;
    e.preventDefault();
    dest.scrollIntoView({ behavior: ridotto.matches ? 'auto' : 'smooth', block: 'center' });
    // stesso bersaglio del tema (l'etichetta della taglia con tabindex -1), così chi usa la tastiera o lo screen reader riparte dalle taglie
    var f = dest.querySelector('.bh-taglie__etichetta') || dest.querySelector('input:not([disabled])');
    if (f && f.focus) setTimeout(function () { f.focus({ preventScroll: true }); }, ridotto.matches ? 0 : 450);
  });
})();
